import * as common from '../apiCommon';
import * as util from '../apiUtils';
import * as DocType from '../../constants/constant_doc_types';
import { saveEntity } from '../entity/api_entity';

export function fetchCustomerDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'entity/customer/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export function deleteCustomer(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.ENTITY,
  });
}

export async function fetchCustomerForEdit(app, params) {
  const { id, path, haveCustomFields, loyaltyDisplay, expiryDays } = params;
  const docType = DocType.ENTITY;
  const doc = await common.getDoc(
    app,
    { id, docType },
    {
      assemble_custom_fields: haveCustomFields,
      loyalty_display: loyaltyDisplay,
      expiry_days: expiryDays
    }
  );

  return util.filterCustomFieldsByViewMode(doc, path);
}

export function saveCustomer(app, dataToSave) {
  return saveEntity(app, dataToSave);
}
